import { render, staticRenderFns } from "./PUDO.vue?vue&type=template&id=059c9e66&"
import script from "./PUDO.vue?vue&type=script&lang=js&"
export * from "./PUDO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports